import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DiscoverStore {
  activeTab: { label: string; key: string };
  setActiveTab: (value: { label: string; key: string }) => void;

  activeCategory: API.FeimaChatBotCategoryListResponse['data']['list'][0];
  setActiveCategory: (value: API.FeimaChatBotCategoryListResponse['data']['list'][0]) => void;

  categoryList?: API.FeimaChatBotCategoryListResponse['data']['list'];
  setCategoryList: (value: API.FeimaChatBotCategoryListResponse['data']['list']) => void;

  discoverList: API.FeimaChatBotDiscoverListResponse['data']['list'];
  setDiscoverList: (value: API.FeimaChatBotDiscoverListResponse['data']['list']) => void;
}

export const useDiscoverStore = create<DiscoverStore>()(
  persist(
    (set) => ({
      activeTab: { label: '首页', key: 'home' },
      activeCategory: { id: 0, name: '全部' },
      categoryList: [],
      discoverList: [],

      setActiveTab(activeTab) {
        set({ activeTab });
      },

      setActiveCategory(activeCategory) {
        set({ activeCategory });
      },

      setCategoryList(categoryList) {
        set({ categoryList });
      },

      setDiscoverList(discoverList) {
        set({ discoverList });
      },
    }),
    {
      name: 'discover-storage',
    },
  ),
);
